<script setup lang="ts">
import messages from '../../../../messages.json';
defineExpose({
  name: 'InquirySendCompleted',
});
</script>
<template>
  <div class="SubmitInfo">
    <div class="SubmitInfo__imagediv">
      <img
        class="SubmitInfo__image"
        src="@spectee/assets/images/img_contact.png"
      />
    </div>
    <dl>
      <dt class="SubmitInfo__label">
        {{ messages.inquiry.success.inquirySend }}
      </dt>
      <dd class="SubmitInfo__value">
        {{ messages.inquiry.success.info1 }}
      </dd>
      <dd class="SubmitInfo__value">
        {{ messages.inquiry.success.info2 }}
      </dd>
      <dd class="SubmitInfo__value">{{ messages.inquiry.success.info3 }}</dd>
    </dl>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.SubmitInfo {
  display: flex;
  flex-direction: column;
  padding: $service-unit * 5;
  align-items: center;
  text-align: center;
  min-width: 200px;

  &__imagediv {
    width: 110px;
    height: 80px;
    overflow: hidden;
  }
  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &__label {
    font-weight: bold;
    font-size: $service-font-size-pp;
    padding-top: $service-unit;
    padding-bottom: $service-unit * 2;
  }
  &__value {
    font-size: $service-font-size-pp;
    line-height: $service-line-height-mf;
  }
}
</style>
